import Text from './Text';
import { TextColor, TextWeight, TextSize, getSize, getColor, getWeight } from './utils';

export default function Base(props) {
  return (
    <Text
      {...props}
      size={TextSize.Base}
     />
  );
}
